import { GenericComponent } from '@/components/GenericComponent';
import { useClassName } from '@/styles/PostTypeArticle';
import { PropsFromComponent } from '@/types/component';

export type ArticleRecommendedProps = PropsFromComponent<typeof ArticleRecommendedComponent>;

export const ArticleRecommendedComponent = GenericComponent({
  styles: { key: 'recommended', useClassName },
});
